export enum VariationModal {
  SEARCH = 'search',
  BUNDLE = 'bundle'
}
